import { render, staticRenderFns } from "./StoryViewerRoute.vue?vue&type=template&id=3828f968&"
import script from "./StoryViewerRoute.vue?vue&type=script&lang=ts&"
export * from "./StoryViewerRoute.vue?vue&type=script&lang=ts&"
import style0 from "./StoryViewerRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports